import FormHeading from "../../components/formHeading";
import SelectUserTypeCom from "../../components/selectUserTypeCom";
import SelectUserTypeData from "../../js/selectUserTypeData";
import AuthLayout from "../../components/AuthLayout";
import registerFunction from "./index.function";
export default function SelectUserType() {
  const { selectedUserType, handleUserTypeSelect } = registerFunction();
  return (
    <AuthLayout isBackBnt={true} isPath={"/login"}>
      <FormHeading title="Please Select" highlightText={"Your User Type"} />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3.5 lg:gap-5 pt-3 sm:pt-5 lg:pt-8 2xl:pt-10">
        {SelectUserTypeData?.map((val, index) => {
          const isLastOddItem =
            SelectUserTypeData?.length % 3 === 1 &&
            index === SelectUserTypeData?.length - 1;
          return (
            <div
              key={index}
              className={`${
                isLastOddItem ? "sm:col-span-1 sm:col-start-2" : ""
              }`}
            >
              <SelectUserTypeCom
                cateCardtitle={val?.cateCardtitle}
                cateCardImg={val?.cateCardImg}
                selectedcateCardImg={val?.selectedIcon}
                isSelected={selectedUserType === val?.roleValue}
                onSelect={() => handleUserTypeSelect(val?.roleValue)}
              />
            </div>
          );
        })}
      </div>
    </AuthLayout>
  );
}
